// One-shot message carried across the reload that follows an asset-class switch (or an entry URL
// that had to be moved to another asset class), shown once by the new page. sessionStorage, not
// localStorage: it belongs to this tab and must not surface in another one.

const NOTICE_KEY = 'okv-asset-class-notice'

// `key` is an i18n key; `params` its named values.
export function writeAssetClassNotice(key, params = {}) {
  try {
    sessionStorage.setItem(NOTICE_KEY, JSON.stringify({ key, params }))
  } catch {
    // A notice is a courtesy: storage being unavailable must never block the switch.
  }
}

// Returns the pending notice ({ key, params }) and forgets it, or null.
export function consumeAssetClassNotice() {
  try {
    const raw = sessionStorage.getItem(NOTICE_KEY)
    sessionStorage.removeItem(NOTICE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}
